import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { Router } from 'react-router'
import getRoutes from '@src/routes'

class Root extends Component {
  render () {
    const { store, history } = this.props
    return (
      <Provider store={store}>
        <Router history={history}>
          {getRoutes(store)}
        </Router>
      </Provider>
    )
  }
}

export default Root



// WEBPACK FOOTER //
// ./src/Root/Root.prod.js